import { useEffect, useState } from "react";
import useDebounce from "@/modules/hooks/use-debounce";
import { useGetZipCode, useGetZipCodeDetails } from "../../modules/routes/location-routes";
import polyglot from "../../utils/polyglot";
import Select from "../select";

const getOptions = (data) => {
  if (data) {
    return data.map(({ city, place_id, location }) => ({
      label: city,
      value: place_id,
      location,
    }));
  }
  return null;
};

const SelectZipCode = ({
  name,
  onChange,
  error,
  disabled,
  value: _value = {},
  placeholder = polyglot.t("common.placeholder.zip_code"),
  ...rest
}) => {
  const [value, setValue] = useState(_value);
  const [term, setTerm] = useState("");
  const debouncedTerm = useDebounce(term);
  const [isLoading, setIsLoading] = useState(false);
  const zipCodeDetails = useGetZipCodeDetails();
  const getZipCode = useGetZipCode(
    { term: debouncedTerm },
    {
      enabled: !!debouncedTerm,
    }
  );

  useEffect(() => {
    const fetchZipCodes = async () => {
      if (debouncedTerm === term && !!debouncedTerm) {
        await getZipCode.refetch();
        setIsLoading(false);
      }
    };
    fetchZipCodes();
  }, [debouncedTerm, term, getZipCode.refetch]);

  const handleChange = (option) => {
    setValue(option);
    if (option?.value) {
      zipCodeDetails.mutateAsync({ place_id: option.value }).then((res) => {
        if (res?.data?.data && res?.data?.data?.city_id && res?.data?.data?.location) {
          onChange({
            label: res.data.data.city,
            value: res.data.data.city_id,
            location: res.data.data.location,
          });
        }
      });
    }
  };

  const handleInputChange = (e) => {
    setIsLoading(true);
    setTerm(e.target.value);
  };

  return (
    <Select
      clearable
      disabled={disabled}
      error={error}
      isLoading={isLoading}
      name={name}
      onChange={handleChange}
      onInputChange={handleInputChange}
      options={getOptions(getZipCode.data?.cities)}
      placeholder={placeholder}
      value={value}
      {...rest}
    />
  );
};

export default SelectZipCode;
